var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
import Loader from "../../../shared-library/components/Loader";
import "@frameworks/salesjourney/stylesheets/components/Generic/SelectDropdownSearch.scss";
var SelectDropdownSearch = function (props) {
    var _a, _b, _c;
    var _d = __read(useState(""), 2), searchText = _d[0], setSearchText = _d[1];
    var _e = __read(useState(""), 2), title = _e[0], setTitle = _e[1];
    var _f = __read(useState(""), 2), selectedOptionLabel = _f[0], setSelectedOptionLabel = _f[1];
    var _g = __read(useState([]), 2), optionList = _g[0], setOptionList = _g[1];
    var _h = __read(useState([]), 2), selectedValue = _h[0], setSelectedValue = _h[1];
    var _j = __read(useState(false), 2), isAllSelected = _j[0], setIsAllSelected = _j[1];
    var handleCheckboxChange = function (e) {
        setSelectedValue(function (prev) {
            var _a, _b;
            var selectedOptions = [];
            var updatedOptionList = optionList.map(function (option) {
                var canSelect = e.target.name === "selectAll"
                    ? e.target.checked
                    : e.target.name === option.value
                        ? e.target.checked
                        : option.selected;
                var updatedOption = __assign(__assign({}, option), { selected: canSelect });
                if (canSelect) {
                    selectedOptions = __spreadArray(__spreadArray([], __read(selectedOptions), false), [
                        { label: updatedOption.label, value: updatedOption.value },
                    ], false);
                }
                return updatedOption;
            });
            setIsAllSelected(((_a = props === null || props === void 0 ? void 0 : props.options) === null || _a === void 0 ? void 0 : _a.length) === selectedOptions.length);
            setOptionList(updatedOptionList);
            if (props === null || props === void 0 ? void 0 : props.onChange) {
                props.onChange(e, selectedOptions, updatedOptionList.length === selectedOptions.length);
            }
            var labels = "";
            selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(function (list) {
                labels += (list === null || list === void 0 ? void 0 : list.label) + ", ";
            });
            if ((selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 2) {
                setTitle(((_b = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) === null || _b === void 0 ? void 0 : _b.toString()) + " Selected");
                setSelectedOptionLabel(labels);
            }
            else if ((selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 0 && (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) <= 2) {
                setTitle(labels);
                setSelectedOptionLabel(labels);
            }
            else {
                setTitle("");
                setSelectedOptionLabel("");
            }
            return selectedOptions;
        });
    };
    useEffect(function () {
        var _a;
        if (((_a = props === null || props === void 0 ? void 0 : props.options) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) > 2) {
                setOptionList(function (prev) {
                    var _a;
                    return (_a = props === null || props === void 0 ? void 0 : props.options) === null || _a === void 0 ? void 0 : _a.filter(function (list) { var _a; return (_a = list.label) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchText.toLowerCase()); }).map(function (list, index) {
                        var _a;
                        return (__assign(__assign({}, list), { selected: ((_a = prev.find(function (prevItem) { return prevItem.value === list.value; })) === null || _a === void 0 ? void 0 : _a.selected) || false }));
                    });
                });
            }
            else {
                setOptionList(function (prevOptionList) {
                    var _a;
                    var updatedList = (_a = props === null || props === void 0 ? void 0 : props.options) === null || _a === void 0 ? void 0 : _a.map(function (list) {
                        var previousItem = prevOptionList === null || prevOptionList === void 0 ? void 0 : prevOptionList.find(function (prev) { return prev.value === list.value; });
                        return __assign(__assign({}, list), { selected: (previousItem === null || previousItem === void 0 ? void 0 : previousItem.selected) || false });
                    });
                    return updatedList;
                });
            }
        }
    }, [searchText]);
    useEffect(function () {
        var _a;
        if (((_a = props === null || props === void 0 ? void 0 : props.options) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setOptionList(props === null || props === void 0 ? void 0 : props.options);
        }
    }, [props === null || props === void 0 ? void 0 : props.options]);
    useEffect(function () {
        var _a;
        if ((props === null || props === void 0 ? void 0 : props.reset) && ((_a = props === null || props === void 0 ? void 0 : props.options) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setOptionList(props === null || props === void 0 ? void 0 : props.options);
            setSelectedOptionLabel("");
            setTitle("");
            setIsAllSelected(false);
        }
    }, [props === null || props === void 0 ? void 0 : props.reset]);
    return (React.createElement(Dropdown, { className: "select-dropdown-search" },
        React.createElement(Dropdown.Toggle, { variant: "success", id: "dropdown-basic", title: selectedOptionLabel }, title ? title : "Select..."),
        React.createElement(Dropdown.Menu, null,
            (props === null || props === void 0 ? void 0 : props.isLoading) ? (React.createElement(Loader, { className: " " })) : (React.createElement("div", { className: "search-box" },
                React.createElement("i", { className: "edel-icon-bold-search" }),
                React.createElement("input", { className: "DMSanN_14_400 txt_blue-tint", type: "search", defaultValue: searchText, value: searchText, placeholder: (_a = props === null || props === void 0 ? void 0 : props.searchPlaceholder) !== null && _a !== void 0 ? _a : "Search ...", "aria-label": "Search", onChange: function (e) {
                        setSearchText(e.target.value);
                    } }))),
            !(props === null || props === void 0 ? void 0 : props.isLoading) && (optionList === null || optionList === void 0 ? void 0 : optionList.length) > 0 ? (React.createElement(React.Fragment, null,
                ((_b = props === null || props === void 0 ? void 0 : props.options) === null || _b === void 0 ? void 0 : _b.length) === (optionList === null || optionList === void 0 ? void 0 : optionList.length) && (React.createElement(Form.Group, { key: " ", className: "filter-checkboxes search-all-check", controlId: "formBasicCheckbox" },
                    React.createElement(Form.Check, { inline: true, type: "checkbox", title: "Select All", label: "Select All", name: "selectAll", checked: isAllSelected, onChange: function (e) {
                            if (e.target.checked) {
                                setIsAllSelected(true);
                            }
                            else {
                                setIsAllSelected(false);
                            }
                            handleCheckboxChange(e);
                        }, id: (_c = "All " + (props === null || props === void 0 ? void 0 : props.id)) !== null && _c !== void 0 ? _c : "" }))), optionList === null || optionList === void 0 ? void 0 :
                optionList.map(function (option, idx) {
                    var _a;
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Form.Group, { key: " ", className: "filter-checkboxes", controlId: "formBasicCheckbox" },
                            React.createElement(Form.Check, { inline: true, type: "checkbox", title: option === null || option === void 0 ? void 0 : option.label, label: option === null || option === void 0 ? void 0 : option.label, name: option === null || option === void 0 ? void 0 : option.value.toString(), 
                                // defaultChecked={isAllSelected}
                                checked: isAllSelected ? isAllSelected : !!(option === null || option === void 0 ? void 0 : option.selected), onChange: function (e) {
                                    handleCheckboxChange(e);
                                }, id: (_a = option === null || option === void 0 ? void 0 : option.value) === null || _a === void 0 ? void 0 : _a.toString() }))));
                }))) : (React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION })))));
};
export default SelectDropdownSearch;
